<div xmlns="http://www.w3.org/1999/html">

    <mat-expansion-panel class="light-flex-card tv-mat-expansion-indicator-light-bg">
        <mat-expansion-panel-header>
            <mat-panel-title class="sub-title">
                Négociations Nationales
            </mat-panel-title>
        </mat-expansion-panel-header>

        <div class="header-item-filters">
            <!-- Search -->
            <!--            <mat-form-field-->
            <!--                    class="tv-ns-white-search-medium"-->
            <!--                    floatLabel="never"-->
            <!--            >-->
            <!--                <mat-icon matPrefix class="small-icon">search</mat-icon>-->
            <!--                <input matInput [formControl]="" name="search"/>-->
            <!--            </mat-form-field>-->

            <!-- Add -->
            <button
                    (click)="openNatioNegoModal()"
                    [disabled]="isNatioNegoBusy"
                    class="tv-round-icon-button-icon-small-light-blue"
            >
                <mat-icon>add</mat-icon>
            </button>
        </div>

        <div class="container" [attr.aria-busy]="isNatioNegoBusy">
            <div class="item" *ngFor="let card of negotiationCards" [attr.inert]="isNatioNegoBusy ? '' : null">
                <div class="item-top-row">
                    <div class="item-header">
                        <span class="discountCode">{{ card.negotiation.negotiationType.id }}</span>
                        <span class="discountLabel" [attr.title]="card.negotiation.negotiationType.name">{{ card.negotiation.negotiationType.name }}</span>
                        <span class="date-range">{{ card.negotiation.startDate }} - {{ card.negotiation.endDate }}</span>
                        <span class="ca" *ngIf="! card.negotiation.rate">{{ card.negotiation.value?.toLocaleString('fr-FR') }}
                            €</span>
                        <span class="ca" *ngIf="! card.negotiation.value">{{ card.negotiation.rate }}
                            %</span>
                    </div>
                    <div class="item-actions">
                        <button type="button" class="tv-round-icon-button-icon-medium-light-blue" aria-label="Modifier la négociation"
                                [disabled]="isNatioNegoBusy" (click)="openNatioNegoModal(card.negotiation, false)">
                            <mat-icon svgIcon="edit"></mat-icon>
                        </button>
                        <button type="button" class="tv-round-icon-button-icon-medium-light-blue" aria-label="Dupliquer la négociation"
                                [disabled]="isNatioNegoBusy" (click)="openNatioNegoModal(card.negotiation, true)">
                            <mat-icon svgIcon="content-copy"></mat-icon>
                        </button>
                        <button type="button" class="tv-round-icon-button-icon-medium-light-blue" aria-label="Supprimer la négociation"
                                [disabled]="isNatioNegoBusy" (click)="removeNatioNegotiation(card.negotiation)">
                            <mat-icon class="material-icons-outlined delete-action-icon">delete</mat-icon>
                        </button>
                    </div>
                </div>
                <div class="condition-summary" *ngFor="let summary of card.tables">
                    <h4 class="conditions-title">{{ summary.label }}</h4>
                    <div class="condition-summary-table-container">
                        <div class="condition-summary-scroll tv-custom-always-visible-scroll-bar">
                            <table mat-table [dataSource]="summary.rows" class="tv-ns-mat-table tv-ns-large-mat-table condition-summary-table">
                                <ng-container *ngFor="let column of conditionSummaryColumns" [matColumnDef]="'category-' + column.id">
                                    <th mat-header-cell *matHeaderCellDef>{{ column.label }}</th>
                                    <td mat-cell *matCellDef="let row">
                                        <span class="condition-summary-cell"
                                              [matTooltip]="row[column.id] ?? ''"
                                              matTooltipClass="custom-tv-tooltip">{{ row[column.id] }}</span>
                                    </td>
                                </ng-container>
                                <tr mat-header-row *matHeaderRowDef="conditionSummaryColumnIds; sticky: true"></tr>
                                <tr mat-row *matRowDef="let row; columns: conditionSummaryColumnIds"></tr>
                                <tr class="conditions-empty-row" *matNoDataRow>
                                    <td [attr.colspan]="conditionSummaryColumnIds.length">Aucune condition</td>
                                </tr>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
            <div *ngIf="isNatioNegoBusy" class="natio-list-loading-overlay" role="status" aria-label="Chargement des négociations nationales">
                <mat-spinner diameter="30" class="light-spinner"></mat-spinner>
            </div>
        </div>
    </mat-expansion-panel>

</div>
